import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/MainPageSections/Delegates/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/MainPageSections/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/MainPageSections/Parameters.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/MainPageSections/Proposals/index.tsx");
